import * as actionTypes from '../../../actionTypes';

export interface ImageUploadDialogueState {
    title?: string | null;
    imageUrl?: string | null;
    imageCategory?: string | null;
    onUpload?: ((imageUrl: string) => void) | null;
    onRemove?: (() => void) | null;
    onClose?: (() => void) | null;
}

export interface ImageUploadDialogueAction {
    type: string;
    payload: ImageUploadDialogueState | null;
}

export interface RootState {
    imageUploadDialogue: ImageUploadDialogueState | null;
    [key: string]: unknown;
}

export function createAction(payload: ImageUploadDialogueState | null): ImageUploadDialogueAction {
    return {
        type: actionTypes.imageUploadDialogueUI,
        payload: payload
    };
}

/**
 * Creates action to remove the uploaded image
 * @param currentImageUploadDialogue - Current imageUploadDialogue state from store
 */
export function createRemoveUploadedImageAction(
    currentImageUploadDialogue: ImageUploadDialogueState
): ImageUploadDialogueAction {
    return {
        type: actionTypes.imageUploadDialogueUI,
        payload: {
            ...currentImageUploadDialogue,
            imageUrl: null
        }
    };
}

/**
 * Creates action to update the uploaded image URL
 * @param currentImageUploadDialogue - Current imageUploadDialogue state from store
 * @param imageUrl - The new image URL
 */
export function updateUploadImageAction(
    currentImageUploadDialogue: ImageUploadDialogueState,
    imageUrl: string
): ImageUploadDialogueAction {
    return {
        type: actionTypes.imageUploadDialogueUI,
        payload: {
            ...currentImageUploadDialogue,
            imageUrl: imageUrl
        }
    };
}

export function changeState(
    previousState: RootState,
    payload: ImageUploadDialogueState | null
): RootState {
    return Object.assign({}, previousState, { imageUploadDialogue: payload });
}

// Default export for backward compatibility with CommonJS imports
export default {
    createAction,
    createRemoveUploadedImageAction,
    updateUploadImageAction,
    changeState
};
